import axios from 'axios';
import router from './../router/index.js';
import storage from '@/fetch/storage';
import bsdrConfig from './config';
import Token from './accessToken';
import {
  Notification
} from 'element-ui';

// axios配置
// axios.defaults.timeout = 20000;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.baseURL = bsdrConfig.apiURL;

// POST传参序列化
axios.interceptors.request.use((config) => {
  console.log(config);
  return config;
}, (error) => {
  return Promise.rejects(error);
})

function buildURL(url, needToken) {
  // url = url + (url.indexOf('?') >= 0 ? '&':'?') + "token=" + token
  let token = Token.getAccessToken();
  if (!needToken) {
    return token ? url + (url.indexOf('?') >= 0 ? '&' : '?') + 'token' + token : url;
  }
  if (!token) {
    storage.set('history_url', router.history.current.path);
    router.replace('/login');
    return false;
  }
  return url + (url.indexOf('?') >= 0 ? '&' : '?') + "token=" + token
}

export function fetchPost(url, params, needToken, isJson) {
  url = buildURL(url, needToken);
  if (!url) {
    return new Promise((resolve, reject) => {
      reject();
    })
  }
  return new Promise((resolve, reject) => {
    // isJson ? {headers: {'Content-Type': 'application/json'}} : {}
    axios.post(url, params).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.log(error.response);
      if (error.response.status == 401) {
        Notification({
          title: 'Warning',
          message: error.response.data.message,
          duration: 2000,
          type: 'warning'
        })
        router.replace('/login');
        return;
      }
      if (error.response.status >= 500) {
        Notification({
          title: 'Error',
          message: 'Network Errors',
          duration: 2000,
          type: "error"
        })
        reject(error.response.data);
        return;
      }
      Notification({
        title: 'Warning',
        message: error.response.data ? error.response.data.message : error.response.message,
        duration: 2000,
        type: 'warning'
      })
      reject(error.response.data);
    })
  })
}

export function fetchGet(url, params, needToken) {

  url = buildURL(url, needToken)
  if (!url) {
    return new Promise((resolve, reject) => {
      reject()
    })
  }
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(response => {
      resolve(response.data);
      console.log("错误信息A", response);

    }).catch(error => {
      console.log("错误信息", error);
      if (error.response.status == 401) {
        router.replace('/login');
        return;
      }
      if (error.response.status >= 500) {
        Notification({
          title: 'Error',
          message: 'Network Errors',
          duration: 2000,
          type: "error"
        })
        reject(error.response.data);
        return;
      }
      Notification({
        title: 'Warning',
        message: error.response.data ? error.response.data.message : error.response.message,
        duration: 2000,
        type: 'warning'
      })
      reject(error.response.data);
    })
  })
}

export function fetchDelete(url, params, needToken) {

  url = buildURL(url, needToken)
  if (!url) {
    return new Promise((resolve, reject) => {
      reject()
    })
  }
  return new Promise((resolve, reject) => {
    axios.delete(url, {
      params: params
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.log(error.response);
      if (error.response.status == 401) {
        router.replace('/login');
        return;
      }
      if (error.response.status >= 500) {
        Notification({
          title: 'Error',
          message: 'Network Errors',
          duration: 2000,
          type: "error"
        })
        reject(error.response.data);
        return;
      }
      Notification({
        title: 'Warning',
        message: error.response.data ? error.response.data.message : error.response.message,
        duration: 2000,
        type: 'warning'
      })
      reject(error.response.data);
    })
  })
}

export default {
  // 登入
  login(params) {
    return fetchPost('/api/auth/login', params, false);
  },
  // 组织架构 新增
  orgStore(params) {
    return fetchPost('/api/org/store', params, true);
  },
  // 组织架构 获取列表
  orgAll(params) {
    return fetchGet('/api/org/all', params, false);
  },
  // 组织架构 编辑
  orgUpdate(params) {
    return fetchPost('/api/org/update', params, true);
  },
  // 组织架构 删除
  orgDelete(params) {
    return fetchDelete(`/api/org/delete/${params.id}`, {}, true);
  },
  //  PL Leader和PL 管理 新增
  userManagerCreate(params) {
    return fetchPost('/api/user/managerCreate', params, true);
  },
  // PL Leader和PL 管理 列表
  userManagerList(params) {
    return fetchGet('/api/user/managerList', params, true);
  },
  // PL Leader和PL 管理 详情
  userManagerInfo(params) {
    return fetchGet(`/api/user/managerInfo/${params.userId}`, {}, true);
  },
  // PL Leader和PL 管理 编辑
  userManagerUpdate(params) {
    return fetchPost('/api/user/managerUpdate', params, true);
  },
  // PL Leader和PL 管理 删除
  userManagerDelete(params) {
    return fetchDelete(`/api/user/managerDelete/${params.userId}`, {}, true);
  },
  // 发送激活验证码
  sendActivateCode(params) {
    return fetchPost('/api/auth/sendActivateCode', params, false);
  },
  // 激活
  authActivate(params) {
    return fetchPost('/api/auth/activate', params, false);
  },
  // 发送找回密码验证码
  sendResetPasswordCode(params) {
    return fetchPost('/api/auth/sendResetPasswordCode', params, false);
  },
  // 重新设置密码
  resetPassword(params) {
    return fetchPost('/api/auth/resetPassword', params, false);
  },
  // 用户信息
  userInfo(params) {
    return fetchPost('/api/auth/userInfo', params, true);
  },
  //  Supplier 管理 新增
  supplierCreate(params) {
    return fetchPost('/api/supplier/create', params, true);
  },
  // 供应商列表
  supplier(params) {
    return fetchGet('/api/supplier', params, true);
  },
  //  Supplier 管理 编辑
  supplierUpdate(params) {
    return fetchPost('/api/supplier/update', params, true);
  },
  //  Supplier 管理 删除
  supplierDelete(params) {
    return fetchDelete(`/api/supplier/delete/${params.userId}`, {}, true);
  },
  // Supplier 管理 地址列表
  getSupplierAddressList(params) {
    return fetchGet('/api/supplier/receivingAddress/getSupplierAddressList', params, true);
  },
  //  FG 个人中心地址 新增
  createUserAddress(params) {
    return fetchPost('/api/supplier/receivingAddress/createUserAddress', params, true);
  },
  //  FG 个人中心地址 用户地址列表
  getUserAddressList(params) {
    return fetchGet('/api/supplier/receivingAddress/getUserAddressList', params, true);
  },
  // FG 个人中心地址 修改
  updateUserAddress(params) {
    return fetchPost('/api/supplier/receivingAddress/updateUserAddress', params, true);
  },
  // FG 个人中心地址 删除
  deleteUserAddress(params) {
    return fetchDelete(`/api/supplier/receivingAddress/deleteUserAddress/${params.id}`, params, true);
  },
  // FG 个人中心地址  设置指定地址为默认地址
  defaultUserAddress(params) {
    return fetchPost(`/api/supplier/receivingAddress/defaultUserAddress/${params.id}`, {}, true);
  },
  //  CPT Supplier 部门管理 部门列表
  supplierDepartment(params) {
    return fetchGet('/api/supplier/department', params, true);
  },
  // 用户Model Number
  modelNumberGetListByUser(params) {
    return fetchGet('/api/modelNumber/getListByUser', params, true);
  },
  // CPT Supplier 部门管理 新增
  supplierDepartmentCreate(params) {
    return fetchPost('/api/supplier/department/create', params, true);
  },
  // CPT Supplier 部门管理 编辑
  supplierDepartmentUpdate(params) {
    return fetchPost('/api/supplier/department/update', params, true);
  },
  // CPT Supplier 部门管理 删除部门
  supplierDepartmentDelete(params) {
    console.log(params);
    return fetchDelete(`/api/supplier/department/delete/${params.id}`, params, true);
  },
  // FG 所有 下拉选择器使用
  supplierFg(params) {
    return fetchGet('/api/supplier/fg', params, true);
  },
  // 订单配置文件
  orderConfig(params) {
    return fetchGet('/api/order/config', params, true);
  },
  // CPT 所有 下拉选择器使用 *
  supplierCpt(params) {
    return fetchGet('/api/supplier/cpt', params, true);
  },
  // 上传附件
  orderAttachmentUploadFile(params) {
    return fetchPost('/api/orderAttachment/uploadFile', params, true);
  },
  // 保存新增  编辑 草稿 和 发送
  orderSave(params) {
    return fetchPost('/api/order/save', params, true, true);
  },
  // 订单列表
  orderList(params) {
    return fetchGet('/api/order/list', params, true);
  },
  // 订单列表 Item
  orderItemList(params) {
    return fetchGet('/api/orderItem/list', params, true);
  },
  // 订单Item Passion Brand
  orderItemSelectPassionBrand(params) {
    return fetchGet('/api/orderItem/selectPassionBrand', params, true);
  },
  // 订单season
  orderSelectSeason(params) {
    return fetchGet('/api/order/selectSeason', params, true);
  },
  // 订单Item season
  orderItemSelectSeason(params) {
    return fetchGet('/api/orderItem/selectSeason', params, true);
  },
  // 单条item的备注
  orderRemarkRemarksByItem(params) {
    return fetchGet(`/api/orderRemark/remarksByItem/${params.id}`, {}, true);
  },
  // 添加item Remark 只传新加的
  orderRemarkCreate(params) {
    return fetchPost('/api/orderRemark/create', params, true);
  },
  // 单条item的附件
  orderAttachmentAttachmentsByItem(params) {
    return fetchGet(`/api/orderAttachment/attachmentsByItem/${params.id}`, {}, true);
  },
  // 更新item附件
  orderAttachmentSave(params) {
    return fetchPost('/api/orderAttachment/save', params, true);
  },
  // 已有Item发送 支持多选
  orderSend(params) {
    return fetchPost('/api/order/send', params, true);
  },
  // 更新item email list
  orderItemUpdateEmailList(params) {
    return fetchPost('/api/orderItem/updateEmailList', params, true);
  },
  // 删除草稿Item
  orderItemDelete(params) {
    return fetchDelete(`/api/orderItem/delete/${params.id}`, {}, true);
  },
  // 删除草稿Order Copy
  orderDelete(params) {
    return fetchDelete(`/api/order/delete/${params.id}`, {}, true);
  },
  // 订单信息
  orderInfo(params) {
    return fetchGet('/api/order/info', params, true);
  },
  // 取消item
  orderCancelled(params) {
    return fetchPost('/api/order/cancelled', params, true);
  },
  // InProgress 统计
  orderInProgressTotal(params) {
    return fetchGet('/api/order/inProgressTotal', params, true);
  },
  // 设置订单etd
  orderSetEtd(params) {
    return fetchPost('/api/order/setEtd', params, true);
  },
  // 批量设置订单etd
  batchSetEtd(params) {
    return fetchPost('/api/order/batchSetEtd', params, true);
  },
  // 设置物流号
  orderSetWaybillNumber(params) {
    return fetchPost('/api/order/setWaybillNumber', params, true);
  },
  // 设置物流号
  batchSetWaybillNumber(params) {
    return fetchPost('/api/order/batchSetWaybillNumber', params, true);
  },
  // 单条item的日志
  orderLogsLogsByItem(params) {
    return fetchGet(`/api/orderLogs/logsByItem/${params.id}`, {}, true);
  },
  // Pending
  orderPending(params) {
    return fetchPost('/api/order/pending', params, true);
  },
  // 注册
  authRegister(params) {
    return fetchPost('/api/auth/registerPl', params, false);
  },
  // 订单号列表
  getOrderNoList(params) {
    return fetchGet('/api/order/getOrderNoList', params, true);
  },
  // Copy  复制订单
  copyOrder(params) {
    return fetchPost('/api/order/copyOrder', params, true);
  },
  // 饼图
  chartsDotCharts(params) {
    return fetchGet('/api/charts/dotCharts', params, true);
  },
  // 折线图
  chartsLeaderTimeCharts(params) {
    return fetchGet('/api/charts/leaderTimeCharts', params, true);
  },
  // 统计下列表
  chartsList(params) {
    return fetchGet('/api/charts/chartsList', params, true);
  },
  //
  orderItemSelectItem(params) {
    return fetchGet('/api/orderItem/selectItem', params, true);
  },
  //
  orgDpp(params) {
    return fetchGet('/api/org/dpp', params, true);
  },
  // 获取excel数据
  orderItemImport(params) {
    return fetchPost('/api/orderItem/import', params, true);
  },
  // 发送找注册验证码
  sendRegisterPlCode(params) {
    return fetchPost('/api/auth/sendRegisterPlCode', params, false);
  },
  // 根据code查询  Supplier
  getSupplierByCode(params) {
    return fetchGet('/api/supplier/getSupplierByCode', params, true);
  },

  // 根据code查询  Supplier列表
  getSupplierListByCode(params) {
    return fetchGet('/api/supplier/getSupplierListByCode', params, true);
  },

  // 绑定供应商
  plBindingSupplier(params) {
    return fetchPost('/api/supplier/plBindingSupplier', params, true);
  },
  // Menu 统计
  orderMenuTotal(params) {
    return fetchGet('/api/order/menuTotal', params, true);
  },
  // Pending reason 修改
  updatePendingReason(params) {
    return fetchPost('/api/order/updatePendingReason', params, true);
  },
  // 获取用户设置
  userSubscribe(params) {
    return fetchGet('/api/user/subscribe', params, true);
  },
  // 保存用户设置
  userSubscribeSave(params) {
    return fetchPost('/api/user/subscribe/save', params, true);
  },
  // 发送取消请求
  orderItemRequestCancel(params) {
    return fetchPost('/api/orderItem/requestCancel', params, true);
  },

  // 供应商处理取消请求
  orderItemHandleRequestCancel(params) {
    return fetchPost('/api/orderItem/handleRequestCancel', params, true);
  },

  // pending 饼图
  chartsPendingCharts(params) {
    return fetchGet('/api/charts/pendingCharts', params, true);
  },

  // Reason Closed 饼图
  chartsCloseCharts(params) {
    return fetchGet('/api/charts/closeCharts', params, true);
  },

  // 获取process列表
  supplierProcess(params) {
    return fetchGet('/api/supplier/process', params, true);
  },

  //  process 新增
  supplierProcessCreate(params) {
    return fetchPost('/api/supplier/process/create', params, true);
  },

  // process 编辑
  supplierProcessUpdate(params) {
    return fetchPost('/api/supplier/process/update', params, true);
  },
  // process 删除
  supplierProcessDelete(params) {
    return fetchDelete(`/api/supplier/process/delete/${params.id}`, {}, true);
  },
  // CPT Supplier 数组
  supplierProcessProcessSupplier(params) {
    return fetchGet('/api/supplier/process/processSupplier', params, true);
  },
  // FG Supplier 数组
  supplierProcessSupplierMerge(params) {
    return fetchGet('/api/supplier/process/processSupplierMerge', params, true);
  },
  // 回复ETD
  batchReplyToEtd(params) {
    return fetchPost('/api/order/batchReplyToEtd', params, true);
  },

  // invoice 列表
  orderInvoiceList(params) {
    return fetchGet('/api/order/invoiceList', params, true);
  },
  // 保存 invoice
  orderSaveInvoice(params) {
    return fetchPost('/api/order/saveInvoice', params, true);
  },
  // 上传ETD回复文件
  orderImportEtdByExcel(params) {
    return fetchPost('/api/order/importEtdByExcel', params, true);
  },
  // 批量上传发票
  orderImportInvoiceByExcel(params) {
    return fetchPost('/api/order/importInvoiceByExcel', params, true);
  },

  // 导入供应商
  supplierImport(params) {
    return fetchPost('/api/supplier/import', params, true);
  },

  // 合并供应商
  supplierMerge(params) {
    return fetchPost('/api/supplier/merge', params, true);
  },

  // 合并发短信
  mergeNotice(params) {
    return fetchPost('/api/supplier/mergeNotice', params, true);
  },

  // 保存CPT PL收货地址
  saveUserAddress(params) {
    return fetchPost('/api/user/saveUserAddress', params, true);
  },

  //  获取地址
  getUserAddress(params) {
    return fetchGet('/api/user/getUserAddress', params, true);
  },

  // 获取邮件列表数据
  getUserNotificationEmails(params) {
    return fetchGet('/api/user/getUserNotificationEmails', params, true);
  },

  // 新增邮件列表数据
  saveUserNotificationEmails(params) {
    return fetchPost('/api/user/saveUserNotificationEmails', params, true);
  },

  // 获取报表
  chartsReportNew(params) {
    return fetchGet('/api/charts/reportNew', params, true);
  },

  //  CPT PL 地址
  getCPTUserAddressList(params) {
    return fetchGet('/api/user/getUserAddressList', params, true);
  },

  // CPL PL 地址 删除
  deleteCPTUserAddress(params) {
    return fetchDelete(`/api/user/delUserAddress/${params.id}`, params, true);
  },

  //  CPL PL 个人中心地址 新增
  addUserAddress(params) {
    return fetchPost('/api/user/addUserAddress', params, true);
  },

  // CPT PL 个人中心地址 修改
  editUserAddress(params) {
    return fetchPost('/api/user/editUserAddress', params, true);
  },

  // FG 个人中心地址  设置指定地址为默认地址
  defaultCPTAddress(params) {
    return fetchPost(`/api/user/defaultUserAddress/${params.id}`, {}, true);
  },

  // 申请供应商
  supplierApply(params) {
    return fetchPost('/api/supplier/apply', params, true);
  },

  //  获取reason
  orderRequestReason(params) {
    return fetchGet('/api/orderRequest/reason', params, true);
  },

  //  申请 只有close才可以
  orderRequestApply(params) {
    return fetchPost('/api/orderRequest/apply', params, true);
  },

  // 审批
  orderRequestApprove(params) {
    return fetchPost('/api/orderRequest/approve', params, true);
  }
}



// WEBPACK FOOTER //
// ./src/fetch/api.js